<template>
  <div>
    <div class="row">
        <div class='form-group col-md-6'>
          <label for="">Data Início</label>
          <date-picker @input="carregarDados" width='100%' v-model='filter.dataInicio' :first-day-of-week='1' lang='pt-br' format='DD-MM-YYYY'></date-picker>
        </div>
        <div class='form-group col-md-6'>
          <label for="">Data Fim</label>
          <date-picker @input="carregarDados" width='100%' v-model='filter.dataFim' :first-day-of-week='1' lang='pt-br' format='DD-MM-YYYY'></date-picker>
        </div>

    </div>
    <table class="table">
      <tr>
        <th>Nome</th>
        <th>Quantidade</th>
      </tr>
      <tr v-for='(dado,index) in dados' :key='`dado-${index}`'>
        <td>{{dado[propriedadeNome]}}</td>
        <td>{{dado.count}}</td>
      </tr>
    </table>
  </div>
</template>
<script>
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import EstatisticasService from '@/services/estatisticas-service'
export default {
  components: {
    DatePicker
  },
  data() {
    return {
      dados: [],
      filter: {
        dataInicio: moment().subtract(1, 'years'),
        dataFim: null
      }
    }
  },
  methods: {
    async carregarDados() {

      const filtro = { 
        dataInicio: this.filter.dataInicio ? moment(this.filter.dataInicio).format('YYYY-MM-DD') : null, 
        dataFim: this.filter.dataFim ? moment(this.filter.dataFim).format('YYYY-MM-DD') : null }

      try {
        const { data } = await EstatisticasService[this.endpoint](filtro)
        this.dados = data
      } catch(e) {

      } finally {

      }

    }
  },
  props: {
    endpoint: {
      type: String,
      required: true
    },
    propriedadeNome: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.carregarDados()
  }
}
</script>
